// all the production urls needed for the project can be added here.

export default Object.freeze({
  login_url: "https://login.fyers.in/?cb=https://verifiedpnl.fyers.in",
  pnl_url: "https://api-a1-prod.fyers.in/myaccount/prod/verified-pnl/get-data",
  hostname: ".fyers.in",
});
